export const BOUND_STORE_ID =
  (typeof window !== "undefined" && window.STORE_ID) || undefined;
export const HAS_BOUND_STORE_ID = !!BOUND_STORE_ID;

export const LOCK_MAINNET =
  process.env.REACT_APP_LOCK_MAINNET &&
  ["true", "1"].includes(process.env.REACT_APP_LOCK_MAINNET?.toLowerCase());
